import { Box, Button, Typography } from "@mui/material";
import CurrencyFormat from "react-currency-format";

import DiscountLogo from "components/DiscountLogo/DiscountLogo";

import protectedShopping from "assets/img/compraProtegida.png";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { saveToShoppingCart } from "helpers/ShoppingCartFunctions";
import { useState } from "react";

export default function ProductInfoOil({ data }) {

  const [selectedLiterIndex, setSelectedLiterIndex] = useState(0);

  const whatsapp_float = {
    backgroundColor: "#25d366",
    padding: "15px",
    color: "#FFF",
    borderRadius: "50px",
    fontSize: "28px",
    boxShadow: "2px 2px 3px #999",
    marginRight: "10px",
    display: "flex",
  };

  if (data === null) {
    return null;
  }

  const rowMini = {
    paddingLeft: "15%",
    paddingRight: "15%",
    marginBottom: "20px",
    fontFamily: "Poppins, sans-serif",
    textAlign: "left",
  };

  const infoTitle = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "500",
    fontSize: "30px",
  };

  return (
    <div
      style={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box
        component="h2"
        sx={{ display: { xs: "none", md: "block" } }}
        style={{ ...infoTitle, fontStyle: "italic" }}
      >
        {data.name}
      </Box>
      <DiscountLogo
        width="200px"
        fontSize="18px"
        discount={data.discountPercentage}
      />

      {data?.liters && (
        <div>
          <div>
            <p style={{ fontSize: "25px" }}>
              {data.discount ? (
                <>
                  <CurrencyFormat
                    value={data.liters[selectedLiterIndex].price}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    displayType={"text"}
                    prefix="$"
                    style={{
                      textDecoration: "line-through",
                      color: "gray",
                      marginRight: "10px",
                    }}
                  />
                  <CurrencyFormat
                    prefix="$"
                    value={data.liters[selectedLiterIndex].discountPrice}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    displayType={"text"}
                    style={{ color: "#E21608" }}
                  />
                </>
              ) : (
                <CurrencyFormat
                  value={data.liters[selectedLiterIndex].price}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  displayType={"text"}
                  prefix="$"
                />
              )}
            </p>

            <div>
              CANTIDAD:
              <select
                value={selectedLiterIndex}
                onChange={(e) => setSelectedLiterIndex(Number(e.target.value))}
                style={{ margin: '10px 10px', padding: '5px' }}
              >
                {data.liters.map((item, idx) => (
                  <option key={idx} value={idx}>
                    {item.liters}
                  </option>
                ))}
              </select>
            </div>

            <Button
              variant="contained"
              color="primary"
              style={{ margin: "10px" }}
            >
              Comprar Ahora
            </Button>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: "10px" }}
              onClick={() => { saveToShoppingCart(data.id, 'aceite', selectedLiterIndex); }}
            >
              Agregar al carrito
            </Button>
          </div>

        </div>
      )}

      <Typography variant="body3" align="center">
        <Box component="span" color="error.main">
          envío GRATIS
        </Box>
        <Box component="span">&nbsp;a partir de $549 en tu carrito</Box>
      </Typography>

      <div
        style={{
          paddingLeft: "15%",
          paddingRight: "15%",
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={protectedShopping}
          alt="compra protegida"
          style={{ height: "30px", width: "30px", margin: "10px" }}
        />
        <Link
          to="/envios-y-pagos"
          style={{ color: "blue", textDecoration: "none" }}
        >
          Compra protegida
        </Link>
      </div>

      <div style={rowMini}>
        El tiempo de entrega del producto estimado es de 2 a 5 días hábiles,
        este puede variar dependiendo el domicilio
      </div>

      <div style={rowMini}>
        Si desea factura favor de enviar sus datos fiscales al correo{" "}
        <b>afinazone@outlook.com</b>
      </div>

      <div style={{ ...rowMini, textAlign: "center" }}>
        ¿TIENES DUDAS SOBRE EL ENVÍO, LA COMPATIBILIDAD O DISPONIBILIDAD DEL
        PRODUCTO?
      </div>

      <div style={{ ...rowMini, display: "flex", justifyContent: "center" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <a
            href="https://wa.me/524613126256 "
            style={whatsapp_float}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsAppIcon style={{ height: "50px", width: "50px" }} />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{ fontFamily: "Poppins, sans-serif", fontSize: "15px" }}
              >
                Atención a clientes
              </div>
              <div
                style={{
                  fontFamily: "Poppins, sans-serif",
                  textDecoration: "none",
                  fontSize: "25px",
                }}
              >
                461-312-6256
              </div>
            </div>
          </a>
        </div>
      </div>

      <div style={{ ...rowMini, textAlign: "center" }}>
        Para más detalles{" "}
        <Link
          to="/envios-y-pagos"
          style={{ color: "#E21608", textDecoration: "none" }}
        >
          click aquí
        </Link>
      </div>
    </div>
  );
}
